import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Prompt, Text } from "@components/mantine";
import { Locales } from "../../../strings/Locales.js";
import { useAccessTableContext } from "../AccessTable.context.js";
export var LoseAccessPrompt = function(param) {
    var onCancellation = param.onCancellation, opened = param.opened, onLoseAccessConfirmation = param.onLoseAccessConfirmation;
    var targetDomain = useAccessTableContext().targetDomain;
    return /*#__PURE__*/ _jsxs(Prompt, {
        variant: "warning",
        opened: opened,
        title: Locales.format("GroupsAccessTable.LoseAccessPrompt.title"),
        onClose: onCancellation,
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                size: "sm",
                pb: "sm",
                children: Locales.format("GroupsAccessTable.LoseAccessPrompt.description", {
                    resourceNameSingular: Locales.formatOrDefault("PrivilegesRows.".concat(targetDomain, ".granular"), {
                        defaultTranslation: targetDomain
                    }).toLowerCase()
                })
            }),
            /*#__PURE__*/ _jsxs(Prompt.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Prompt.CancelButton, {
                        onClick: onCancellation,
                        children: Locales.format("GroupsAccessTable.LoseAccessPrompt.UndoChange")
                    }),
                    /*#__PURE__*/ _jsx(Prompt.ConfirmButton, {
                        onClick: onLoseAccessConfirmation,
                        children: Locales.format("GroupsAccessTable.LoseAccessPrompt.LoseEditorAccess")
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=LoseAccessPrompt.js.map